import { render, staticRenderFns } from "./ManagementTable.vue?vue&type=template&id=54c8c66b&"
import script from "./ManagementTable.vue?vue&type=script&lang=js&"
export * from "./ManagementTable.vue?vue&type=script&lang=js&"
import style0 from "./ManagementTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports